import { render, staticRenderFns } from "./FailComponent.vue?vue&type=template&id=16b996d2&"
import script from "./FailComponent.vue?vue&type=script&lang=js&"
export * from "./FailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports